import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const [currentWord, setCurrentWord] = useState(0);
  const words = ['Investment', 'Evaluation', 'Selection'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [words.length]);

  const handleInternalRedirect = () => {
    navigate('/sign-up');
  };

  return (
    <HeroContainer>
      <Content>
      <Label>ACTIVELY POWERING STARTUPS TO RAISE FUNDS</Label>
        <Title>
          The Intelligence Stack for
          <br />
          <Text>Startup {' '}</Text>
          <WordContainer>
            <AnimatedWord key={currentWord}> {words[currentWord]}</AnimatedWord>
          </WordContainer>
        </Title>
        <Subtitle>We are the <span>brain</span> behind startup investments</Subtitle>
        <GetStartedButton onClick={handleInternalRedirect}>Get Started</GetStartedButton>
      </Content>
    </HeroContainer>
  );
};

const slideUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HeroContainer = styled.div`
  padding: 60px 0;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Label = styled.span`
  display: inline-flex;
  padding: 8px 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgb(255, 255, 255), rgba(255, 126, 27, 0.1));
  color: #ff5924;
  border: 0.05px solid rgba(255, 157, 133,0.5) ;
  box-shadow: 0 10px 50px rgba(162, 42, 1, 0.1);
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 32px;
`;

const Content = styled.div`
  margin-top: 110px;
  margin-bottom: 50px;
  text-align: center;
  @media (max-width: 768px) {
    margin-top: 160px;
    margin-bottom: 100px;
  }
`;

const Text = styled.text`
  margin-left: -120px !important;
  @media (max-width: 768px) {
    margin-left: 0px !important;
  }  
  `;

const Title = styled.h1`
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 24px;
  color: #000;
  
  span {
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media (max-width: 768px) {
    font-size: 60px;
  }
`;

const AnimatedWord = styled.span`
  position: absolute;
  padding-left: 10px;
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${slideUp} 0.5s ease-out;
  display: inline-block;
  @media (max-width: 768px) {
    text-align: center;
    position: relative;
  }
`;

const WordContainer = styled.span`
  display: inline-block;
  position: relative;
  width: auto;
  min-width: 300px;
  text-align: left;
  height:1em;
`;

const Subtitle = styled.h2`
  font-size: 30px;
  margin-bottom: 16px;
  color: #333;

  span {
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const GetStartedButton = styled.button`
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #E63D1A;
  }
`;

export default HeroSection;
